import React, { Component } from 'react';
import PanelHolder from '../model/PanelHolder.js';
import { listenTo, clearBindings } from '../util/Utility.js';

export default class ApproveUserView extends Component {

  fetchObjects(limit, callback) {
    listenTo("pending_users", this, callback);
  }

  componentWillUnmount() {
    clearBindings();
  }

  render() {
    return ( <center>
      <h3>User Approval</h3>
      <p style={{maxWidth: 500}}>Only approve users if you know the email corresponds to a known church or ministry leader at Calvary Chapel Orlando.</p>
      <PanelHolder type="user_approval" approval fetchObjects={this.fetchObjects.bind(this)} {...this.props} />
    </center> );
  }
}



/** WEBPACK FOOTER **
 ** ./src/approvals/ApproveUserView.js
 **/